<hr class="devider" />
<section class="flex gap-4" [class]="vm.mode">
  <section class="flex items-center gap-8">
    <i class="fa-light" [class]="vm.icon"></i>
    <p class="label">{{ vm.title }}</p>
  </section>
  <section class="flex gap-8">
    <p class="body">{{ vm.copy }}</p>
    <a class="link-text" href="{{ vm.link }}">{{ vm.linkLabel }}</a>
  </section>
</section>
